import { CaretRightOutlined, StepBackwardOutlined, StepForwardOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { WebClient } from '../webclient';
import './raceplayer.scss';

/* -------------------------------------------------------------------------------- *\
|                               RacePlayerProps
\* -------------------------------------------------------------------------------- */
interface RacePlayerProps
{
    ws: React.MutableRefObject<WebClient>,
    timefromstart: string,
	children?: Node,
}
/* -------------------------------------------------------------------------------- *\
|                               RacePlayer
\* -------------------------------------------------------------------------------- */
export const RacePlayer : FC<RacePlayerProps> = ({ws, timefromstart}) =>
{
    /* -------------------------------------------------------------------------------- *\
    |                               ws_send
    \* -------------------------------------------------------------------------------- */
    const ws_send = (ws: WebClient, cmd: string, datas: string) => 
    {
        ws.send_cmd(cmd, datas);
    }

    return (
        <div className="raceplayer">
            <div className='raceplayer__separator'></div>
            <div className='raceplayer__buttons'>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "begin")}><StepBackwardOutlined /></div>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "prev")}>
                    <span role="img" aria-label="double-left" className="anticon">
                        <svg viewBox="0 0 1024 1024" focusable="false" data-icon="fast-backward" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path d="M100 512L500 180L500 844zM500 512L900 180L900 844z"></path>
                        </svg>
                    </span>
                </div>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "play")}><CaretRightOutlined /></div>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "stop")}>
                    <span role="img" aria-label="caret-right" className="anticon">
                        <svg viewBox="0 0 1024 1024" focusable="false" data-icon="caret-right" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path d="M180 180L180 844L844 844L844 180z"></path>
                        </svg>
                    </span>
                </div>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "next")}>
                <span role="img" aria-label="double-left" className="anticon">
                        <svg viewBox="0 0 1024 1024" focusable="false" data-icon="fast-backward" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                            <path d="M900 512L500 180L500 844zM500 512L100 180L100 844z"></path>
                        </svg>
                    </span>                                            
                </div>
                <div className='raceplayer__buttons__button' onClick={() => ws_send(ws.current, "playercmd", "end")}><StepForwardOutlined /></div>
            </div>
            {/* {
                timefromstart &&
                <div className='raceplayer__startin'>{"Start in " + timefromstart + "s"}</div>
            } */}
        </div>

    );
}
